import { gql } from '@apollo/client';

export function updateMarine() {
  return gql`
    mutation modifyMarineDetails(
      $entityId: String!
      $policyMarineInput: Production_PolicyMarineInputs!
    ) {
      production {
        entities {
          policy {
            production {
              modifyMarineDetails(
                entityId: $entityId
                policyMarineInput: $policyMarineInput
              )
            }
          }
        }
      }
    }
  `;
}
